import "reflect-metadata"
import Vue from "vue"
import AmplilyWidget from "./single-widget.vue"
import { AwOptions } from "../models/AwOptions"
import { callSetup } from "@/services/setupAmplilyWidget"
import state from "@/mixins/state"
import setupOptions from "@/mixins/SetupData"
import { addMetaTag } from "@/services/addMetaTag"
import isPreview from "@/services/isPreview"
import addMaterialIcons from "@/services/addMaterialDesign"
import logger from "../logLevel"
import { WebinarDataService } from "@/services/WebinarDataServices"
import { container } from "tsyringe"
import {
  registerAnalyticsService,
  registerWebinarDataService
} from "@/tsyringe.config"
Vue.config.productionTip = process.env.NODE_ENV != "production"
;(window as any).setupAmplilySingle = (options: AwOptions) => {
  const el = document.getElementsByClassName("parmonic-widget")[0]
  new Vue({
    render: h => h(AmplilyWidget),
    mixins: [state, setupOptions],
    created() {
      let isPrev = false
      this.$data.logger = logger
      addMetaTag()
      addMaterialIcons()
      this.$data.identifierKey += 1
      if (options && options.apiEndpoint)
        this.$data.baseurlAdminAppUrl = options.apiEndpoint + "/"
      if (options && options.dataEndpoint)
        this.$data.PublishedWebinarDataEndPoint = options.dataEndpoint + "/"
      this.$data.queryEndpoint =
        options && options.queryEndpoint ? options.queryEndpoint : ""
      isPrev = isPreview()
      if (options && options.webinarData) {
        isPrev = true
        registerWebinarDataService(true)
        const _dataService = container.resolve(WebinarDataService)
        _dataService.setUp("undefined", "undefined", options.webinarData)
      } else {
        registerWebinarDataService(false)
        const _dataService = container.resolve(WebinarDataService)
        _dataService.setUp(
          this.$data.PublishedWebinarDataEndPoint + "v/",
          this.$data.queryEndpoint,
          {}
        )
      }
      this.$data.time_data.startTime =
        options && options.startTime ? options.startTime : undefined
      this.$data.time_data.endTime =
        options && options.endTime ? options.endTime : undefined
      this.$data.time_data.screenshotTime =
        options && options.screenshotTime ? options.screenshotTime : undefined
      this.$data.eventElement =
        options && options.eventElement ? options.eventElement : undefined
      this.$data.autoPlay = options && options.autoPlay ? true : false
      this.$data.redirect_data.url =
        options && options.redirect_data ? options.redirect_data.url : undefined
      this.$data.redirect_data.text =
        options && options.redirect_data
          ? options.redirect_data.text
          : undefined
      this.$data.analyticsEventsCaptureEndPoint = `${this.$data.baseurlAdminAppUrl}api/v4/event`
      registerAnalyticsService(isPrev || process.env.NODE_ENV != "production")
    }
  }).$mount(el!)
}
callSetup()
